export default "__VITE_ASSET__coMgj0nl__"